<template>
  <PmNotePure
    v-if="job"
    :note="note"
    :error-message="xstate.state.value.context.error"
    :error-details="xstate.state.value.context.errorDetails"
    :state="pureState"
    :edit-button-visible="$can('edit', 'persoplan')"
    @save="(value) => xstate.service.value.send('UPDATE', { value })"
    @cancel="xstate.service.value.send('CANCEL')"
  />
</template>

<script>
import { defineComponent, getCurrentInstance } from 'vue'
import PmNotePure from '@/components/PmNote/PmNotePure.vue'
import { throwFriendlyError } from '@/functional/error'
import { useXState } from '@/composition/useXState'
import { PmNoteState } from '@/components/PmNote/PmNoteState'
import {
  NoteJobDocument,
  UpdateNoteJobDocument,
} from '../../../generated/graphql'
import { isNil } from 'lodash-es'

export default defineComponent({
  name: 'PmNoteJob',
  components: {
    PmNotePure,
  },

  props: {
    id: { type: Number, default: undefined },
  },

  setup() {
    const instance = getCurrentInstance()

    const xstate = useXState(PmNoteState, {
      services: {
        updateNote: (context, { value }) => instance.ctx.updateNote(value),
      },
    })
    return {
      xstate,
    }
  },

  data() {
    return {
      job: undefined,
    }
  },

  computed: {
    note() {
      return this.job?.comment
    },

    pureState() {
      if (this.xstate.state.value.matches('update.updating')) {
        return 'editing.saving'
      }

      if (this.xstate.state.value.matches('update.failed')) {
        return 'editing.failed'
      }

      if (this.xstate.state.value.matches('default')) {
        return 'default'
      }

      return undefined
    },
  },

  methods: {
    async updateNote(value) {
      /**
       * Normalizel value to empty string if undefined as a Workaround for bug in API
       * @see https://gitlab.dev.innovation-agents.de/ia/pro-musik/organisation/-/work_items/390
       */
      const valueNormalized = isNil(value) ? '' : value

      try {
        await this.$apollo.mutate({
          mutation: UpdateNoteJobDocument,

          variables: {
            id: this.id,
            note: valueNormalized,
          },
        })
      } catch (error) {
        throwFriendlyError(error)
      }
    },
  },

  apollo: {
    job: {
      query: NoteJobDocument,
      fetchPolicy: 'cache-and-network',

      variables() {
        return {
          id: this.id,
        }
      },
    },
  },
})
</script>
